/* ARBACH — Foto auf der Flasche (Auftrag 62, 30.10.2026). Markup und Stil:
   snippets/shop-foto-druck.liquid, im Produktformular unter der Größenwahl.

   Ohne dieses Skript bleibt der Kasten verborgen und alle seine Felder sind
   gesperrt — der Kauf geht wie bisher.

   1. Sichtbarkeit je Größe: 100 ml → Kasten; 50 ml → Zeile „nur auf 100 ml“
      mit Knopf, der die 100-ml-Kachel wählt (derselbe Klick wie von Hand:
      Preise und Kaufleiste per :has(), Adresse per history.replaceState aus
      snippets/shop-groessenwahl.liquid); 5 ml (Probe) → nichts. Datei und Gruß
      bleiben beim Wechsel erhalten, die Felder sind aber nur frei, solange
      100 ml gewählt UND der Schalter an ist — sonst geht nichts davon mit.
   2. Datei: nur JPEG, PDF, EPS, höchstens 20 MB (sonst Meldung, Feld wird
      geleert). JPEG: Maße und EXIF-Drehung aus dem Dateikopf → wirksame
      Auflösung auf der Druckfläche 58 × 97 mm (2,283 × 3,819 Zoll):
      ≥ 250 dpi „passt“, 150–249 „reicht“, darunter Hinweis (blockiert nicht).
      JPEG breiter als hoch (nach der Drehung): Querformat-Hinweis unter der
      Zeile, blockiert ebenfalls nicht (Auftrag 68).
      Vorschau nur im Browser (Object-URL), nichts wird dafür hochgeladen.
   3. Absenden (alle Knöpfe des Formulars, auch die Kaufleiste), nur bei
      100 ml + Schalter an: Datei oder Gruß und das Häkchen sind Pflicht.
      Dann setzt das Skript die Eigenschaften (_Bildrechte, _Aufloesung,
      sichtbar Druck/Gruß) und schickt das Formular per XMLHttpRequest mit
      FormData an /cart/add.js — so ist der Fortschritt sichtbar. Danach
      Warenkorb bzw. bei „Jetzt kaufen“ /checkout. Fehler: Meldung am Kasten,
      nichts geht verloren. Ohne FormData/XHR: normales Absenden.
   4. Beispiele (Auftrag 68): Kachelbreite so, dass eine ganze Zahl Kacheln
      in die Zeile passt (72–112 px) — am Rand nie ein halbes Bild. Unter
      768 px wechseln sie alle 3 s eine Kachel weiter, halten bei Berührung,
      Maus darüber und Fokus an, bei prefers-reduced-motion gar nicht. Ab
      768 px kein Wechsel; passen nicht alle hinein, blättern zwei Pfeile um
      eine Zeile (arabisch gespiegelt). Bilder des Kastens laden erst beim
      Aufklappen (data-src).
   Keine Analyse-Ereignisse, keine Weitergabe an Dritte. */
(function () {
  'use strict';

  var box = document.querySelector('[data-foto]');
  if (!box) return;
  var form = box.closest('form');
  if (!form) return;

  // Texte aus den Sprachdateien; Shopifys t maskiert ' als &#39; — hier zurück in Klartext
  var T = {};
  try { T = JSON.parse(box.querySelector('[data-foto-texte]').textContent); } catch (e) {}
  var dekoder = document.createElement('textarea');
  Object.keys(T).forEach(function (k) { dekoder.innerHTML = T[k]; T[k] = dekoder.value; });
  var V100 = box.getAttribute('data-foto-variante');
  var MAX = Number(box.getAttribute('data-foto-max')) || 20971520;
  var ZOLL_B = 58 / 25.4, ZOLL_H = 97 / 25.4;   // Druckfläche 2,283 × 3,819 Zoll

  function q(s) { return box.querySelector(s); }
  var schalter = q('[data-foto-schalter]');
  var inhalt = q('[data-foto-inhalt]');
  var bereich = q('[data-foto-bereich]');
  var datei = q('[data-foto-datei]');
  var feld = q('[data-foto-feld]');
  var zeile = q('[data-foto-zeile]');
  var mini = q('[data-foto-mini]');
  var miniSymbol = q('[data-foto-mini-symbol]');
  var dateiName = q('[data-foto-name]');
  var status = q('[data-foto-status]');
  var vorschau = q('[data-foto-vorschau]');
  var vorschauHinweis = q('[data-foto-vorschau-hinweis]');
  var vBild = q('[data-foto-vorschau-bild]');
  var vLogo = q('[data-foto-vorschau-logo]');
  var vGruss = q('[data-foto-vorschau-gruss]');
  var gruss = q('[data-foto-gruss]');
  var zaehler = q('[data-foto-zaehler]');
  var rechteFeld = q('[data-foto-rechte-feld]');
  var rechte = q('[data-foto-rechte]');
  var fehlerDatei = q('[data-foto-fehler="datei"]');
  var fehlerRechte = q('[data-foto-fehler="rechte"]');
  var fehlerSenden = q('[data-foto-fehler="senden"]');
  var liste = q('[data-foto-beispiele]');
  var pfeile = q('[data-foto-pfeile]');
  var quer = q('[data-foto-quer]');
  var props = {};
  Array.prototype.forEach.call(box.querySelectorAll('[data-foto-prop]'), function (el) {
    props[el.getAttribute('data-foto-prop')] = el;
  });
  var nur100 = document.querySelector('[data-foto-nur100]');
  var setZeile = document.querySelector('[data-foto-set]');

  var objektUrl = null;   // Vorschau der gewählten Datei
  var info = null;        // { art: 'jpeg'|'pdf'|'eps', w, h, dpi }
  var dateiNr = 0;        // gegen späte Antworten einer vorigen Auswahl
  var bilderDa = false;
  var busy = false;

  // ------------------------------------------------------------ Größe und Lage
  function gewaehlt() { return form.querySelector('.arbach-buy__radio:checked'); }
  function ist100() { var r = gewaehlt(); return !!r && r.value === V100; }
  function istProbe() { var r = gewaehlt(); return !!r && r.classList.contains('arbach-buy__radio--probe'); }
  function aktiv() { return schalter.checked && ist100(); }

  function lage() {
    var r = gewaehlt(), r100 = ist100();
    box.hidden = !r100;
    if (nur100) nur100.hidden = !r || r100 || istProbe();
    inhalt.hidden = !schalter.checked;
    var an = aktiv();
    datei.disabled = !an;
    gruss.disabled = !an;
    rechte.disabled = !an;
    Object.keys(props).forEach(function (k) { props[k].disabled = true; });   // erst beim Absenden
    if (setZeile) setZeile.hidden = !an;
    datei.tabIndex = zeile.hidden ? 0 : -1;
    if (an) bilderLaden();
    leiste();
    karussell();
  }

  function bilderLaden() {
    if (bilderDa) return;
    bilderDa = true;
    Array.prototype.forEach.call(box.querySelectorAll('img[data-src]'), function (img) {
      img.src = img.getAttribute('data-src');
      img.removeAttribute('data-src');
    });
  }

  // ------------------------------------------------------------------ Meldungen
  function meldung(el, text) {
    if (!el) return;
    el.textContent = '';
    if (text) window.setTimeout(function () { el.textContent = text; }, 30);
  }
  function fehlerWeg() {
    meldung(fehlerDatei, ''); meldung(fehlerRechte, ''); meldung(fehlerSenden, '');
    datei.removeAttribute('aria-invalid'); rechte.removeAttribute('aria-invalid');
  }
  function zeigeFehler(el, text, fokus) {
    meldung(el, text);
    if (fokus) {
      fokus.setAttribute('aria-invalid', 'true');
      try { fokus.focus({ preventScroll: true }); } catch (e) { fokus.focus(); }
    }
    var ziel = el && el.parentNode ? el.parentNode : box;
    if (ziel.scrollIntoView) ziel.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }

  // ------------------------------------------------------------------- Datei
  function dateiArt(f) {
    var n = (f.name || '').toLowerCase();
    var t = (f.type || '').toLowerCase();
    if (t) {
      if (t === 'image/jpeg' || t === 'image/pjpeg') return 'jpeg';
      if (t === 'application/pdf') return 'pdf';
      if (t === 'application/postscript' || t === 'application/eps' || t === 'application/x-eps' || t === 'image/eps' || t === 'image/x-eps') return 'eps';
      if (t !== 'application/octet-stream') return null;
    }
    if (/\.jpe?g$/.test(n)) return 'jpeg';
    if (/\.pdf$/.test(n)) return 'pdf';
    if (/\.eps$/.test(n)) return 'eps';
    return null;
  }

  // Maße und EXIF-Drehung aus dem JPEG-Kopf; liefert die Maße NACH der Drehung.
  function exifDrehung(d, t) {
    if (t + 8 > d.byteLength) return 0;
    var le = d.getUint16(t) === 0x4949;
    var ifd = d.getUint32(t + 4, le);
    if (t + ifd + 2 > d.byteLength) return 0;
    var n = d.getUint16(t + ifd, le);
    for (var i = 0; i < n; i++) {
      var e = t + ifd + 2 + i * 12;
      if (e + 12 > d.byteLength) return 0;
      if (d.getUint16(e, le) === 0x0112) return d.getUint16(e + 8, le);
    }
    return 0;
  }
  function jpegKopf(buf) {
    var d = new DataView(buf);
    if (d.byteLength < 4 || d.getUint16(0) !== 0xFFD8) return { keinJpeg: true };
    var o = 2, dreh = 1, w = 0, h = 0;
    while (o + 4 <= d.byteLength) {
      if (d.getUint8(o) !== 0xFF) { o++; continue; }
      var m = d.getUint8(o + 1);
      if (m === 0xFF) { o++; continue; }
      if (m === 0x01 || (m >= 0xD0 && m <= 0xD8)) { o += 2; continue; }
      if (m === 0xD9 || m === 0xDA) break;
      var len = d.getUint16(o + 2);
      if (m === 0xE1 && o + 10 <= d.byteLength && d.getUint32(o + 4) === 0x45786966) {
        dreh = exifDrehung(d, o + 10) || dreh;
      }
      if (m >= 0xC0 && m <= 0xCF && m !== 0xC4 && m !== 0xC8 && m !== 0xCC) {
        if (o + 9 > d.byteLength) break;
        h = d.getUint16(o + 5); w = d.getUint16(o + 7);
        break;
      }
      o += 2 + len;
    }
    if (!w || !h) return null;
    return dreh >= 5 && dreh <= 8 ? { w: h, h: w } : { w: w, h: h };
  }
  function lies(f, cb) {
    try {
      var r = new FileReader();
      r.onload = function () { var k = null; try { k = jpegKopf(r.result); } catch (e) {} cb(k); };
      r.onerror = function () { cb(null); };
      r.readAsArrayBuffer(f.slice(0, 1048576));
    } catch (e) { cb(null); }
  }

  function setzeStatus(text, hinweis) {
    status.textContent = '';
    var haken = document.createElement('span');
    haken.setAttribute('aria-hidden', 'true');
    haken.textContent = hinweis ? '' : '✓ ';
    status.appendChild(haken);
    status.appendChild(document.createTextNode(text));
    status.classList.toggle('arbach-foto__status--hinweis', !!hinweis);
  }
  function qualitaet() {
    if (!info) return;
    var a = T.ausgewaehlt || '';
    if (info.art !== 'jpeg') { setzeStatus(a + ' · ' + (T.logo || ''), false); return; }
    if (!info.dpi) { setzeStatus(a, false); return; }
    if (info.dpi >= 250) setzeStatus(a + ' · ' + (T.passt || ''), false);
    else if (info.dpi >= 150) setzeStatus(a + ' · ' + (T.reicht || ''), false);
    else setzeStatus(a + ' · ' + (T.klein || ''), true);
  }
  function masse(w, h) {
    info.w = w; info.h = h;
    info.dpi = Math.min(w / ZOLL_B, h / ZOLL_H);
    qualitaet();
    querHinweis(w > h);
  }
  // Querformat: zusätzlicher Hinweis, blockiert nichts; Hochformat und quadratisch: keiner
  function querHinweis(an) { if (quer) quer.textContent = an ? (T.quer || '') : ''; }

  function freigeben() {
    if (objektUrl) { try { URL.revokeObjectURL(objektUrl); } catch (e) {} }
    objektUrl = null; info = null;
    querHinweis(false);
    mini.removeAttribute('src'); vBild.removeAttribute('src');
  }
  function zeigeFeld() { feld.hidden = false; zeile.hidden = true; datei.tabIndex = 0; }
  function zeigeZeile() { feld.hidden = true; zeile.hidden = false; datei.tabIndex = -1; }

  function waehle() {
    fehlerWeg();
    var nr = ++dateiNr;
    var f = datei.files && datei.files[0];
    freigeben();
    if (!f) { zeigeFeld(); aktualisieren(); return; }
    var art = dateiArt(f);
    if (!art || f.size > MAX) {
      datei.value = '';
      zeigeFeld();
      aktualisieren();
      zeigeFehler(fehlerDatei, art ? T.gross : T.typ, datei);
      return;
    }
    info = { art: art };
    dateiName.textContent = f.name;
    if (art === 'jpeg') {
      objektUrl = URL.createObjectURL(f);
      mini.src = objektUrl; mini.hidden = false; miniSymbol.setAttribute('hidden', '');   // SVG: nur das Attribut wirkt
      vBild.src = objektUrl;
      qualitaet();
      lies(f, function (k) {
        if (nr !== dateiNr || !info) return;
        if (k && k.keinJpeg) {                    // Endung .jpg, Inhalt etwas anderes
          datei.value = ''; freigeben(); zeigeFeld(); aktualisieren();
          zeigeFehler(fehlerDatei, T.typ, datei);
          return;
        }
        if (k) { masse(k.w, k.h); return; }
        // Kopf nicht lesbar: Maße vom Bild selbst (Browser beachtet die EXIF-Drehung)
        var probe = new Image();
        probe.onload = function () { if (nr === dateiNr && info) masse(probe.naturalWidth, probe.naturalHeight); };
        probe.src = objektUrl;
      });
    } else {
      mini.hidden = true; miniSymbol.removeAttribute('hidden');
      qualitaet();
    }
    zeigeZeile();
    aktualisieren();
  }

  function hatDatei() { return !!(info && datei.files && datei.files.length); }
  function hatGruss() { return gruss.value.trim() !== ''; }

  function aktualisieren() {
    var d = hatDatei(), g = hatGruss();
    vorschau.hidden = !(d || g);
    vorschauHinweis.hidden = vorschau.hidden;
    vBild.hidden = !(d && info.art === 'jpeg');
    vLogo.hidden = !(d && info.art !== 'jpeg');
    var text = gruss.value.trim();
    vGruss.hidden = d || !g;
    vGruss.textContent = text;
    vGruss.classList.toggle('arbach-foto__druck-gruss--mittel', text.length > 25 && text.length <= 70);
    vGruss.classList.toggle('arbach-foto__druck-gruss--klein', text.length > 70);
    rechteFeld.hidden = !(d || g);
    zaehler.textContent = gruss.value.length + '/150';
  }

  function hoeheAnpassen() {
    if (window.CSS && CSS.supports && CSS.supports('field-sizing', 'content')) return;
    gruss.style.height = 'auto';
    gruss.style.height = gruss.scrollHeight + 2 + 'px';   // max-height (4 Zeilen) steht im Stil
  }

  // -------------------------------------------------------------- Beispiele
  var takt = null, pauseHand = false, pauseFokus = false, pauseMaus = false, handTimer = null;
  var wenigBewegung = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var breit = window.matchMedia ? window.matchMedia('(min-width: 768px)') : null;
  var KACHEL_MIN = 72, KACHEL_MAX = 112;   // px, Hochformat 9 : 16
  var sicht = 1, schritt = 0;              // ganze Kacheln je Zeile, Kachel + Spalt
  function istBreit() { return !!(breit && breit.matches); }

  // Eine ganze Zahl Kacheln je Zeile: k = so viele, wie mit mindestens 72 px
  // hineinpassen, dann die Breite so, dass genau k die Zeile füllen. Passen alle,
  // höchstens 112 px breit (sonst würden sie am Laptop riesig).
  function leiste() {
    if (!liste) return;
    var stil = window.getComputedStyle(liste);
    var spalt = parseFloat(stil.columnGap) || 0;
    var w = liste.clientWidth - (parseFloat(stil.paddingLeft) || 0) - (parseFloat(stil.paddingRight) || 0);
    var n = liste.children.length;
    if (w <= 0 || !n) return;   // Kasten zu: nichts zu messen
    var k = Math.max(1, Math.min(n, Math.floor((w + spalt) / (KACHEL_MIN + spalt))));
    var kachel = (w - (k - 1) * spalt) / k;
    if (k === n) kachel = Math.min(kachel, KACHEL_MAX);
    kachel = Math.floor(kachel * 100) / 100;
    liste.style.setProperty('--fd-kachel', kachel + 'px');
    sicht = k;
    schritt = kachel + spalt;
    if (pfeile) pfeile.hidden = !(istBreit() && k < n);
    pfeilStand();
  }
  function pfeilStand() {
    if (!pfeile || pfeile.hidden) return;
    var max = liste.scrollWidth - liste.clientWidth;
    var pos = Math.abs(liste.scrollLeft);   // RTL: scrollLeft läuft ins Negative
    Array.prototype.forEach.call(pfeile.querySelectorAll('[data-foto-pfeil]'), function (b) {
      var zurueck = b.getAttribute('data-foto-pfeil') === '-1';
      b.setAttribute('aria-disabled', (zurueck ? pos <= 1 : pos >= max - 1) ? 'true' : 'false');
    });
  }
  function blaettern(richtung) {
    var rtl = window.getComputedStyle(liste).direction === 'rtl';
    var ruhig = wenigBewegung && wenigBewegung.matches;
    liste.scrollBy({ left: richtung * sicht * schritt * (rtl ? -1 : 1), behavior: ruhig ? 'auto' : 'smooth' });
  }

  function karussell() {
    if (takt) { window.clearInterval(takt); takt = null; }
    if (!liste || box.hidden || inhalt.hidden || istBreit() || (wenigBewegung && wenigBewegung.matches)) return;
    takt = window.setInterval(weiter, 3000);
  }
  function weiter() {
    if (pauseHand || pauseFokus || pauseMaus || document.hidden) return;
    var k = liste.querySelector('li');
    if (!k) return;
    var stil = window.getComputedStyle(liste);
    var schritt = k.getBoundingClientRect().width + (parseFloat(stil.columnGap) || 0);
    var max = liste.scrollWidth - liste.clientWidth;
    if (max <= 1) return;
    var rtl = stil.direction === 'rtl';
    if (Math.abs(liste.scrollLeft) >= max - 2) liste.scrollTo({ left: 0, behavior: 'smooth' });
    else liste.scrollBy({ left: rtl ? -schritt : schritt, behavior: 'smooth' });
  }
  if (liste) {
    liste.addEventListener('mouseenter', function () { pauseMaus = true; });
    liste.addEventListener('mouseleave', function () { pauseMaus = false; });
    liste.addEventListener('focusin', function () { pauseFokus = true; });
    liste.addEventListener('focusout', function () { pauseFokus = false; });
    var hand = function () {
      pauseHand = true;
      window.clearTimeout(handTimer);
      handTimer = window.setTimeout(function () { pauseHand = false; }, 6000);
    };
    liste.addEventListener('touchstart', hand, { passive: true });
    liste.addEventListener('pointerdown', hand);
    liste.addEventListener('wheel', hand, { passive: true });
    if (wenigBewegung && wenigBewegung.addEventListener) wenigBewegung.addEventListener('change', karussell);
    liste.addEventListener('scroll', pfeilStand, { passive: true });
    if (pfeile) pfeile.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-foto-pfeil]') : null;
      if (!b || b.getAttribute('aria-disabled') === 'true') return;
      blaettern(Number(b.getAttribute('data-foto-pfeil')));
    });
    if (breit && breit.addEventListener) breit.addEventListener('change', function () { leiste(); karussell(); });
    if (window.ResizeObserver) new ResizeObserver(function () { leiste(); }).observe(liste);
    else window.addEventListener('resize', leiste);
  }

  // ---------------------------------------------------------------- Absenden
  function jetztIso() {
    var d = new Date(), z = -d.getTimezoneOffset(), v = z >= 0 ? '+' : '-';
    function p(n) { return (n < 10 ? '0' : '') + n; }
    z = Math.abs(z);
    return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate()) + 'T' + p(d.getHours()) + ':' +
      p(d.getMinutes()) + ':' + p(d.getSeconds()) + v + p(Math.floor(z / 60)) + ':' + p(z % 60);
  }
  function setze(el, wert) {
    if (!el) return;
    if (!wert) { el.disabled = true; return; }
    el.value = wert; el.disabled = false;
  }
  function eigenschaften() {
    var d = hatDatei(), g = hatGruss();
    datei.disabled = !d;                       // leeres Datei-Feld nicht mitschicken
    gruss.disabled = !g;
    setze(props.gruss, g ? gruss.value.trim() : '');
    setze(props.bildrechte, 'bestätigt ' + jetztIso());
    var aufl = '';
    if (d && info.art === 'jpeg') {
      aufl = info.w ? info.w + ' × ' + info.h + ' px, ≈ ' + Math.round(info.dpi / 10) * 10 + ' dpi' : 'JPEG';
    } else if (d) {
      aufl = info.art.toUpperCase();
    }
    setze(props.aufloesung, aufl);
    setze(props.flasche, props.flasche ? props.flasche.value : '');
    setze(props.druck, props.druck ? props.druck.value : '');
  }

  var knoepfeText = [];
  function sperren(knopf) {
    busy = true;
    knoepfeText = [];
    Array.prototype.forEach.call(form.querySelectorAll('button[type="submit"]'), function (b) {
      knoepfeText.push([b, b.innerHTML, b.disabled]);
      b.disabled = true;
    });
    if (knopf) knopf.setAttribute('aria-busy', 'true');
  }
  function entsperren() {
    busy = false;
    knoepfeText.forEach(function (k) { k[0].innerHTML = k[1]; k[0].disabled = k[2]; k[0].removeAttribute('aria-busy'); });
    knoepfeText = [];
  }

  function hochladen(knopf, zurKasse) {
    var fd = new FormData(form);
    fd.delete && fd.delete('return_to');
    sperren(knopf);
    var xhr = new XMLHttpRequest();
    var wurzel = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    xhr.open('POST', wurzel + 'cart/add.js');
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    var anzeige = function (p) { if (knopf) knopf.textContent = (T.laden || '').replace('[[p]]', String(p)); };
    if (hatDatei() && xhr.upload) {
      anzeige(0);
      xhr.upload.onprogress = function (ev) { if (ev.lengthComputable) anzeige(Math.min(99, Math.round(ev.loaded / ev.total * 100))); };
    }
    xhr.onload = function () {
      if (xhr.status >= 200 && xhr.status < 300) {
        if (knopf && hatDatei()) anzeige(100);
        window.location.href = zurKasse ? '/checkout' : (T.warenkorb || '/cart');
        return;
      }
      fehlschlag(xhr.status === 413 ? T.gross : T.upload);
    };
    xhr.onerror = function () { fehlschlag(T.upload); };
    xhr.ontimeout = xhr.onerror;
    xhr.send(fd);
  }
  function fehlschlag(text) {
    entsperren();
    lage();
    zeigeFehler(fehlerSenden, text, null);
  }

  var letzterKnopf = null;
  form.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('button[type="submit"]') : null;
    if (b) letzterKnopf = b;
  }, true);

  document.addEventListener('submit', function (e) {
    if (e.target !== form) return;
    var knopf = e.submitter || letzterKnopf;
    letzterKnopf = null;
    if (!aktiv()) { lage(); return; }                 // ohne Foto: alles wie bisher
    if (busy) { e.preventDefault(); return; }
    fehlerWeg();
    if (!hatDatei() && !hatGruss()) {
      e.preventDefault();
      zeigeFehler(fehlerDatei, T.leer, zeile.hidden ? datei : q('[data-foto-aendern]'));
      return;
    }
    var f = datei.files && datei.files[0];
    if (f && (!dateiArt(f) || f.size > MAX)) {
      e.preventDefault();
      zeigeFehler(fehlerDatei, dateiArt(f) ? T.gross : T.typ, datei);
      return;
    }
    if (!rechte.checked) {
      e.preventDefault();
      zeigeFehler(fehlerRechte, T.rechte, rechte);
      return;
    }
    eigenschaften();
    var zurKasse = !!(knopf && knopf.name === 'return_to');
    if (!window.FormData || !window.XMLHttpRequest) return;   // Rückfall: normales Absenden (multipart)
    e.preventDefault();
    hochladen(knopf, zurKasse);
  });

  // ---------------------------------------------------------------- Ereignisse
  form.addEventListener('change', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('arbach-buy__radio')) lage();
  });
  schalter.addEventListener('change', function () { fehlerWeg(); lage(); });
  datei.addEventListener('change', waehle);
  q('[data-foto-aendern]').addEventListener('click', function () { datei.click(); });
  q('[data-foto-entfernen]').addEventListener('click', function () {
    datei.value = '';
    dateiNr++;
    freigeben();
    zeigeFeld();
    fehlerWeg();
    aktualisieren();
    datei.focus();
  });
  gruss.addEventListener('input', function () { hoeheAnpassen(); aktualisieren(); });
  rechte.addEventListener('change', function () { if (rechte.checked) { meldung(fehlerRechte, ''); rechte.removeAttribute('aria-invalid'); } });
  var zu100 = document.querySelector('[data-foto-zu100]');
  if (zu100) zu100.addEventListener('click', function () {
    var r = form.querySelector('.arbach-buy__radio[value="' + V100 + '"]');
    if (!r) return;
    r.click();
    lage();
    schalter.focus();
  });
  window.addEventListener('pageshow', function () {
    if (busy) entsperren();
    lage();
    if (datei.files && datei.files.length && !info) waehle();
    aktualisieren();
  });

  lage();
  aktualisieren();
})();
